/*
 * @Date: 2025-10-17 15:01:33
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2025-10-17 15:03:33
 */
import { defineAppConfig } from 'ice';
import { defineFrameworkConfig } from '@ice/plugin-icestark/types';
import PageLoading from './components/PageLoading';
import Entry from './entry';
const envCDNMap = {
  dev: 'https://robo-static-dev-obs.momenta.cn',
  qa: 'https://robo-static-qa-obs.momenta.cn',
  online: 'https://robo-static-online-obs.momenta.cn',
}
const pathMap = {
  '/resource/vehicles': '/robo-resource-management/vehicles.html',
  '/resource/vehicle-teams': '/robo-resource-management/vehicle-teams.html',
  '/resource/tos-management': '/robo-resource-management/tos-management.html',
  '/resource/ground-staff': '/robo-resource-management/ground-staff.html',
  '/resource/operation-plan': '/robo-resource-management/operation-plan.html',
  '/config/groups': '/robo-resource-management/groups.html',
  '/odd/point': '/robo-resource-management/point.html',
  '/odd/point-details': '/robo-resource-management/point-details.html',
  '/odd/point-create': '/robo-resource-management/point-create.html',
  '/odd/area': '/robo-resource-management/area.html',
  '/order/dispatch-categories': '/robotaxi-dispatch-platform-web/dispatch-categories.html',
  '/order/orders': '/robotaxi-dispatch-platform-web/orders.html',
  '/order/vehicles': '/robotaxi-dispatch-platform-web/vehicles.html',
  '/ticket/tickets': '/robo-workorder-management/tickets.html',
  '/ticket/anomaly': '/robo-workorder-management/anomaly.html',
  '/analysis/multi-monitor': '/robo-platform-dlv-fe/multi-monitor.html',
  '/analysis/dlv-trend': '/robo-platform-dlv-fe/dlv-trend.html',
  '/analysis/single-monitor': '/robo-platform-dlv-fe/single-monitor.html',
  '/devops/toscase': '/robo-platform-dlv-fe/toscase.html',
  '/devops/tosseat': '/robo-platform-dlv-fe/tosseat.html',
  '/analysis/taxi-trend': '/robo-platform-dlv-fe/taxi-trend.html',
}


const entryMap = {}
Object.keys(envCDNMap).map(env => {
  entryMap[env] = {};
  Object.keys(pathMap).map((key) => {
    entryMap[env][key] = envCDNMap[env] + pathMap[key];
  });
});


export const icestark = defineFrameworkConfig(() => ({
  layout: Entry,
  getApps: () => {
    const originMapData = entryMap[ENV];
    // // resource-management微应用
    // originMapData['/resource/vehicles'] = "/micro/robo-resource-management/" // /micro/robo-resource-management/ -> http://localhost:6004/
    // originMapData['/resource/vehicle-teams'] = "/micro/robo-resource-management/"
    // originMapData['/odd/point'] = "/micro/robo-resource-management/"
    // originMapData['/odd/area'] = "/micro/robo-resource-management/"
    // originMapData['/resource/ground-staff'] = "/micro/robo-resource-management/"
    // originMapData['/resource/operation-plan'] = "/micro/robo-resource-management/"
    // originMapData['/resource/tos-management'] = "/micro/robo-resource-management/"
    // originMapData['/config/groups'] = "/micro/robo-resource-management/"
    // // workOder-management微应用
    // originMapData['/ticket/tickets'] = "http://localhost:6005/"
    // originMapData['/ticket/anomaly'] = "http://localhost:6005/"
    // // dlv-fe微应用
    // originMapData['/analysis/multi-monitor'] = "http://localhost:6002/"
    // originMapData['/analysis/taxi-trend'] = "http://localhost:6002/"
    // originMapData['/analysis/dlv-trend'] = "http://localhost:6002/"
    // originMapData['/devops/toscase'] = "http://localhost:6002/"
    // originMapData['/devops/tosseat'] = "http://localhost:6002/"
    // // dispatch-platform微应用
    // originMapData['/order/dispatch-categories'] = "http://localhost:6003/"
    // originMapData['/order/vehicles'] = "http://localhost:6003/"
    // originMapData['/order/orders'] = "http://localhost:6003/"

    const taxiAppsData = Object.keys(originMapData).map((key) => {
      return {
        path: "/taxi" + key,
        title: "Robotaxi",
        // loadScriptMode: 'fetch' as const,
        loadScriptMode: 'script' as const,
        entry: originMapData[key] + '?ts=' + Date.now(),
      }
    })
    const dlvAppsData = Object.keys(originMapData).map((key) => {
      return {
        path: "/dlv" + key,
        title: "RoboDelivery",
        // loadScriptMode: 'fetch' as const,
        loadScriptMode: 'script' as const,
        // sandbox: true, // 关闭沙箱，避免与 React Query 等库冲突
        entry: originMapData[key] + '?ts=' + Date.now(),
      }
    })
    return taxiAppsData.concat(dlvAppsData);
  },

  appRouter: {
    LoadingComponent: PageLoading,
  },
}));

export default defineAppConfig(() => ({
  app: {
    rootId: 'app',
  },
}));
